import { render, staticRenderFns } from "./CampaignFormDropDownNew.vue?vue&type=template&id=2bf437c0"
import script from "./CampaignFormDropDownNew.vue?vue&type=script&lang=js"
export * from "./CampaignFormDropDownNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports